"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import posthog from "posthog-js";

/**
 * Component that opts out of PostHog tracking when on admin pages.
 * This ensures admin pages are never tracked, even with client-side navigation.
 */
export function PostHogAdminExclusion() {
  const pathname = usePathname();

  useEffect(() => {
    // Only run in production where PostHog is initialized
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    // Check if we're on an admin page
    const isAdminPage = pathname?.startsWith('/admin') ?? false;

    if (isAdminPage) {
      // Opt out of capturing on admin pages
      posthog.opt_out_capturing();
    } else {
      // Opt back in when navigating away from admin pages
      posthog.opt_in_capturing();
    }
  }, [pathname]);

  return null;
}
